import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../views/Layout/Layout.vue'
import Cookies from "@/utils/Cookies";
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
VueRouter.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => err);
}
var res_z = JSON.parse(Cookies.get("rule")) || [];
var redirectType="/openOrder/order"
if (res_z.includes("1") && !res_z.includes("2")) {
    redirectType="/openOrder/order"
  } else if (res_z.includes("2")) {
    redirectType="/openOrder/orderCheckOut"
  } else {
    redirectType="/home"
  }
Vue.use(VueRouter)
    /**
     * 
     * hidden  //是否需要隐藏标题栏 true 隐藏 
     * hiddenBack  //是否需要隐藏返回按钮 true 隐藏 
     * backTip  // 表单页面返回提示一下确认 true 提示
     */

const routes = [{
        path: '/login',
        name: 'login',
        component: () =>
            import ('../views/Login/Login.vue'),
        meta: {
            hidden: true,
            title: '登录'
        }
    },
    {
        path: '/forget',
        name: 'forget',
        component: () =>
            import ('../views/Login/Forget.vue'),
        meta: {
            title: '重置密码'
        }
    },
    {
        path: '/userRegister',
        name: 'userRegister',
        component: () =>
            import ('../views/Login/UserRegister.vue'),
        meta: {
            title: '新用户注册'
        }
    },


    /**
     * 8888888888888888888888888888888888888888888888888888888888888888这里是---主屏----开始
     */
    {
        path: '/',
        name: 'i',
        component: Layout,
        redirect: redirectType,//重定向开单或者收银
        children: [
            {
                path: '/openOrder/order',
                name: 'openOrder_order',
                component: () =>
                    import ('../views/Work/openOrder/order.vue'),
                meta: {
                    title: '开单'
                }
            },
            {
                path: '/openOrder/orderCheckOut',
                name: 'openOrder_orderCheckOut',
                component: () =>
                    import ('../views/Work/openOrder/orderCheckOut.vue'),
                meta: {
                    title: '收银台'
                }
            },
            {
            path: '/home',
            name: 'home',
            component: () =>
                import ('../views/Layout/Home.vue'),
                meta: {
                    title: '首页',
                    hidden: true,
                }
            },{
                path: '/homeStaff',
                name: 'homeStaff',
                component: () =>
                    import ('../views/Layout/HomeStaff.vue'),
                meta: {
                    title: '首页',
                    hidden: true,
                }
            },
            {
                path: '/manage',
                name: 'manage',
                component: () =>
                    import ('../views/Layout/Manage.vue'),
                meta: {
                    title: '管理',
                    hidden: true,
                }
            },
            {
                path: '/user',
                name: 'user',
                component: () =>
                    import ('../views/Layout/User.vue'),
                meta: {
                    title: '我的',
                    hidden: true,
                }
            },
        ]
    },
    /**
     * 8888888888888888888888888888888888888888888888888888888888888888这里是---主屏----结束
     */


    /**
     * 8888888888888888888888888888888888888888888888888888888888888888这里是---开单模块----开始
     */
    {
        path: '/openOrder/test',
        name: 'openOrder_test',
        component: () =>
            import ('../views/Work/openOrder/test.vue'),
        meta: {
            title: '开单测试'
        }
    },
    // {
    //     path: '/openOrder/order',
    //     name: 'openOrder_order',
    //     component: () =>
    //         import ('../views/Work/openOrder/order.vue'),
    //     meta: {
    //         title: '开单'
    //     }
    // },
    // {
    //     path: '/openOrder/orderCheckOut',
    //     name: 'openOrder_orderCheckOut',
    //     component: () =>
    //         import ('../views/Work/openOrder/orderCheckOut.vue'),
    //     meta: {
    //         title: '收银台'
    //     }
    // },
    {
        path: '/openOrder/changeOrder',
        name: 'openOrder_changeOrder',
        component: () =>
            import ('../views/Work/openOrder/changeOrder.vue'),
        meta: {
            title: '改单'
        }
    },
    {
        path: '/openOrder/selectBatch',
        name: 'openOrder_selectBatch',
        component: () =>
            import ('../views/Work/openOrder/selectBatch.vue'),
        meta: {
            title: '添加商品'
        }
    },
    {
        path: '/openOrder/changeGoods',
        name: 'openOrder_changeGoods',
        component: () =>
            import ('../views/Work/openOrder/changeGoods.vue'),
        meta: {
            title: '添加商品'
        }
    },
    {
        path: '/openOrder/orderPay',
        name: 'openOrder_orderPay',
        component: () =>
            import ('../views/Work/openOrder/orderPay.vue'),
        meta: {
            title: '结算'
        }
    },
    {
        // 结账算退款的
        path: '/openOrder/orderPayBack',
        name: 'openOrder_orderPayBack',
        component: () =>
            import ('../views/Work/openOrder/orderPayBack.vue'),
        meta: {
            title: '结算'
        }
    },

    /**
     * 8888888888888888888888888888888888888888888888888888888888888888这里是---开单模块----结束
     */


    /**
     * 8888888888888888888888888888888888888888888888888888888888888888这里是---赊欠管理----开始
     */
    {
        path: '/credit/creditList',
        name: 'credit_creditList',
        component: () =>
            import ('../views/Work/credit/creditList.vue'),
        meta: {
            title: '欠款列表'
        }
    },
    {
        path: '/credit/addCredit',
        name: 'credit_addCredit',
        component: () =>
            import ('../views/Work/credit/addCredit.vue'),
        meta: {
            title: '订单补录'
        }
    },
    {
        path: '/credit/fastPayment',
        name: 'credit_fastPayment',
        component: () =>
            import ('../views/Work/credit/fastPayment.vue'),
        meta: {
            title: '快速还款'
        }
    },
    {
        path: '/credit/fastPaymentOrder',
        name: 'credit_fastPaymentOrder',
        component: () =>
            import ('../views/Work/credit/fastPaymentOrder.vue'),
        meta: {
            title: '选择订单还款'
        }
    },
    {
        path: '/credit/payment',
        name: 'credit_payment',
        component: () =>
            import ('../views/Work/credit/payment.vue'),
        meta: {
            title: '还款'
        }
    },


    /**
     * 8888888888888888888888888888888888888888888888888888888888888888这里是---赊欠管理----结束
     */

    /**
     * 8888888888888888888888888888888888888888888888888888888888888888这里是---管理模块----开始
     */

    /**
     * 订单管理
     */
    {
        path: '/manage/order/orderManage',
        name: 'manage_order_orderManage',
        component: () =>
            import ('../views/Work/manage/order/orderManage.vue'),
        meta: {
            title: '订单管理',
            hidden: false,
        }
    },
    {
        path: '/manage/order/orderDetail',
        name: 'manage_order_orderDetail',
        component: () =>
            import ('../views/Work/manage/order/orderDetail.vue'),
        meta: {
            title: '订单详情',
            hidden: false,
        }
    },
    {
        path: '/manage/order/selectTime',
        name: 'manage_order_selectTime',
        component: () =>
            import ('../views/Work/manage/order/selectTime.vue'),
        meta: {
            title: '选择时间',
            hidden: false,
        }
    },

    /**
     * 买家管理
     */
    {
        path: '/manage/buyer/buyerManage',
        name: 'manage_buyer_buyerManage',
        component: () =>
            import ('../views/Work/manage/buyer/buyerManage.vue'),
        meta: {
            title: '买家管理',
            hidden: false,
        }
    },
    {
        path: '/manage/buyer/buyerDetail',
        name: 'manage_buyer_buyerDetail',
        component: () =>
            import ('../views/Work/manage/buyer/buyerDetail.vue'),
        meta: {
            title: '买家详情',
            hidden: false,
        }
    },
    {
        path: '/manage/buyer/addBuyer',
        name: 'manage_buyer_addBuyer',
        component: () =>
            import ('../views/Work/manage/buyer/addBuyer.vue'),
        meta: {
            title: '添加买家',
            hidden: false,
        }
    },

    /**
     * 货主管理
     */
    {
        path: '/manage/owner/ownerManage',
        name: 'manage_owner_ownerManage',
        component: () =>
            import ('../views/Work/manage/owner/ownerManage.vue'),
        meta: {
            title: '货主管理',
            hidden: false,
        }
    },
    {
        path: '/manage/owner/ownerDetail',
        name: 'manage_owner_ownerDetail',
        component: () =>
            import ('../views/Work/manage/owner/ownerDetail.vue'),
        meta: {
            title: '货主详情',
            hidden: false,
        }
    },
    {
        path: '/manage/owner/addOwner',
        name: 'manage_owner_addOwner',
        component: () =>
            import ('../views/Work/manage/owner/addOwner.vue'),
        meta: {
            title: '添加货主',
            hidden: false,
        }
    },
    /***商品分类 */

    
   {
       path: '/manage/goods/goodsManage',
       name: 'manage_goods_goodsManage',
       component: () =>
           import ('../views/Work/manage/goods/goodsManage.vue'),
       meta: {
           title: '商品分类',
           hidden: false,
       }
   },

    /**
     * 库存管理
     */
    {
        path: '/manage/stock/stockManage',
        name: 'manage_stock_stockManage',
        component: () =>
            import ('../views/Work/manage/stock/stockManage.vue'),
        meta: {
            title: '库存管理',
            hidden: false,
        }
    },
    {
        path: '/manage/stock/editStock',
        name: 'manage_stock_editStock',
        component: () =>
            import ('../views/Work/manage/stock/editStock.vue'),
        meta: {
            title: '编辑货品',
            hidden: false,
            backTip:true,
        }
    },
    {
        path: '/manage/stock/addStock',
        name: 'manage_stock_addStock',
        component: () =>
            import ('../views/Work/manage/stock/addStock.vue'),
        meta: {
            title: '新增库存',
            hidden: false,
            backTip:true,
        }
    },
    {
        path: '/manage/stock/addGoods',
        name: 'manage_stock_addGoods',
        component: () =>
            import ('../views/Work/manage/stock/addGoods.vue'),
        meta: {
            title: '添加货品',
            hidden: false,
            backTip:true,
        }
    },
    {
        path: '/manage/stock/addAddition',
        name: 'manage_stock_addAddition',
        component: () =>
            import ('../views/Work/manage/stock/addAddition.vue'),
        meta: {
            title: '添加附加费',
            hidden: false,
        }
    },
    {
        path: '/manage/stock/brakeDetail',
        name: 'manage_stock_brakeDetail',
        component: () =>
            import ('../views/Work/manage/stock/brakeDetail.vue'),
        meta: {
            title: '报损动态',
            hidden: false,
        }
    },
    {
        path: '/manage/stock/addBrake',
        name: 'manage_stock_addBrake',
        component: () =>
            import ('../views/Work/manage/stock/addBrake.vue'),
        meta: {
            title: '添加报损',
            hidden: false,
        }
    },
    /**
     * 进货管理
     */
    {
        path: '/manage/purchase/purchaseManage',
        name: 'manage_purchase_purchaseManage',
        component: () =>
            import ('../views/Work/manage/purchase/purchaseManage.vue'),
        meta: {
            title: '进货管理',
            hidden: false,
        }
    },
    {
        path: '/manage/purchase/purchaseDetail',
        name: 'manage_purchase_purchaseDetail',
        component: () =>
            import ('../views/Work/manage/purchase/purchaseDetail.vue'),
        meta: {
            title: '批次详情',
            hidden: false,
        }
    },

    /**
     * 销售管理
     */
    {
        path: '/manage/sale/saleManage',
        name: 'manage_sale_saleManage',
        component: () =>
            import ('../views/Work/manage/sale/saleManage.vue'),
        meta: {
            title: '销售统计',
            hidden: false,
        }
    },
    {
        path: '/manage/sale/saleGoodsDetail',
        name: 'manage_sale_saleGoodsDetail',
        component: () =>
            import ('../views/Work/manage/sale/saleGoodsDetail.vue'),
        meta: {
            title: '货品销售明细',
            hidden: false,
        }
    },
    {
        path: '/manage/sale/saleBatchDetail',
        name: 'manage_sale_saleBatchDetail',
        component: () =>
            import ('../views/Work/manage/sale/saleBatchDetail.vue'),
        meta: {
            title: '批次统计',
            hidden: false,
        }
    },
    /**
     * 附加费
     */
    {
        path: '/manage/sale/addExtraFee',
        name: 'manage_sale_addExtraFee',
        component: () =>
            import ('../views/Work/manage/extra/addExtraFee.vue'),
        meta: {
            title: '新增附加费',
            hidden: false,
        }
    },

    /**
     * 8888888888888888888888888888888888888888888888888888888888888888这里是---管理模块----结束
     */

    /**
     * 8888888888888888888888888888888888888888888888888888888888888888这里是---我的模块----开始
     */
    {
        path: '/mine/employee/employeeManage',
        name: 'mine_employee_employeeManage',
        component: () =>
            import ('../views/Work/mine/employee/employeeManage.vue'),
        meta: {
            title: '员工管理',
            hidden: false,
        }
    },
    {
        path: '/mine/employee/employeeDetail',
        name: 'mine_employee_employeeDetail',
        component: () =>
            import ('../views/Work/mine/employee/employeeDetail.vue'),
        meta: {
            title: '员工详情',
            hidden: false,
        }
    },
    {
        path: '/mine/employee/employeeLimit',
        name: 'mine_employee_employeeLimit',
        component: () =>
            import ('../views/Work/mine/employee/employeeLimit.vue'),
        meta: {
            title: '角色设置',
            hidden: false,
        }
    },
    {
        path: '/mine/employee/addEmployee',
        name: 'mine_employee_addEmployee',
        component: () =>
            import ('../views/Work/mine/employee/addEmployee.vue'),
        meta: {
            title: '添加员工',
            hidden: false,
        }
    },
    {
        path: '/mine/bill/billManage',
        name: 'mine_bill_billManage',
        component: () =>
            import ('../views/Work/mine/bill/billManage.vue'),
        meta: {
            title: '货品管理',
            hidden: false,
        }
    },
    {
        path: '/mine/bill/billDetail',
        name: 'mine_bill_billDetail',
        component: () =>
            import ('../views/Work/mine/bill/billDetail.vue'),
        meta: {
            title: '编辑货品',
            hidden: false,
        }
    },
    {
        path: '/mine/sys/sysSet',
        name: 'mine_sys_sysSet',
        component: () =>
            import ('../views/Work/mine/sys/sysSet.vue'),
        meta: {
            title: '系统设置',
            hidden: false,
        }
    },
    {
        path: '/mine/sys/resetPassword',
        name: 'mine_sys_resetPassword',
        component: () =>
            import ('../views/Work/mine/sys/resetPassword.vue'),
        meta: {
            title: '重置密码',
            hidden: false,
        }
    },
    {
        path: '/mine/sys/shopList',
        name: 'mine_sys_shopList',
        component: () =>
            import ('../views/Work/mine/sys/shopList.vue'),
        meta: {
            title: '切换店铺',
            hidden: false,
        }
    },
    {
        path: '/mine/feedBack/feedBackUpload',
        name: 'mine_feedBack_feedBackUpload',
        component: () =>
            import ('../views/Work/mine/feedBack/feedBackUpload.vue'),
        meta: {
            title: '意见反馈',
            hidden: false,
        }

    },
    {
        path: '/mine/printer/printerManage',
        name: 'mine_printer_printerManage',
        component: () =>
            import ('../views/Work/mine/printer/printerManage.vue'),
        meta: {
            title: '打印机管理',
            hidden: false,
        }
    },
    {
        path: '/mine/role/roleManage',
        name: 'mine_role_roleManage',
        component: () =>
            import ('../views/Work/mine/role/roleManage.vue'),
        meta: {
            title: '角色管理',
            hidden: false,
        }
    },
    {
        path: '/mine/role/addRole',
        name: 'mine_role_addRole',
        component: () =>
            import ('../views/Work/mine/role/addRole.vue'),
        meta: {
            title: '添加角色',
            hidden: false,
        }
    },
    {
        path: '/mine/printer/addPrinter',
        name: 'mine_printer_addPrinter',
        component: () =>
            import ('../views/Work/mine/printer/addPrinter.vue'),
        meta: {
            title: '添加打印机',
            hidden: false,
        }
    },
    {
        path: '/mine/myData/myData',
        name: 'mine_myData_myData',
        component: () =>
            import ('../views/Work/mine/myData/myData.vue'),
        meta: {
            title: '个人资料',
            hidden: false,
        }
    },
    /**
     * 8888888888888888888888888888888888888888888888888888888888888888这里是---我的模块----结束
     */

    {
        path: '/public/scan',
        name: 'public_scan',
        component: () =>
            import ('../views/Public/scan.vue'),
        meta: {
            title: '扫一扫',
            hidden: true,
        }
    },
    // 网络出错页面

    {
        path:'/netWork/error',
        name:'network_error',
        component:()=>
            import('../views/error/network_error.vue'),
            meta: {
                title: '网络出错',
                hidden: true,
            }
    }

]


const router = new VueRouter({
    // mode: 'history' ,
    routes,
    scrollBehavior(to, from, savedPssition) {
        if (savedPssition) {
            return savedPssition;
        } else {
            return { x: 0, y: 0 }
        }
    }
})

export default router